// @flow

import React, { Fragment } from 'react';
import NavLink from 'hoc/portalPath/NavLink';
import toUIAddress from '@active/awe-ui-core/lib/dataTransfer/address';
import AddressStatic from 'react-aaui/lib/form/AddressStatic';
import Row from 'react-aaui/lib/grid/Row';
import Col from 'react-aaui/lib/grid/Col';
import Button from 'react-aaui/lib/Button';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';
import compose from 'lodash/fp/compose';
import values from 'lodash/fp/values';
import compact from 'lodash/fp/compact';

import './SearchParticipantListItem.scss';

type Props = {
  participantId: string,
  firstName: string,
  lastName: string,
  gender: string,
  age: string,
  bib: string,
  address: string,
  raceName: string,
  locale: string,
  isKioskMode: boolean,
  queryString: string,
}

const SearchParticipantListItem = ({
  participantId,
  firstName,
  lastName,
  gender,
  age,
  bib = '--',
  address,
  raceName,
  locale,
  isKioskMode,
  queryString,
}: Props) => {
  const uiAddress = address && toUIAddress(address);
  let genderAgePair = <Fragment>
    {gender}
    {' '}
    |
    {' '}
    <L10nMessage id="global.participant.age" />
    {' '}
    {age}
  </Fragment>;
  if (!gender || !age) {
    const ageDisplay = age ? <Fragment>
      <L10nMessage id="global.participant.age" />
      {' '}
      {age}
    </Fragment> : '';
    genderAgePair = gender || ageDisplay;
  }
  const hasAddress = !!(uiAddress && compose(compact, values)(uiAddress).length > 0);
  return (
    <li className="search-participant-list-item">
      <Row fluid align="center">
        <Col sm={2}>
          <strong>
            <NavLink to={`/participants/${participantId}${isKioskMode ? queryString : ''}`}>
              {firstName}
              {' '}
              {lastName}
            </NavLink>
          </strong>
          <br />
          <small>
            {genderAgePair}
          </small>
        </Col>
        <Col sm={2}>
          <strong>{bib}</strong>
          <br />
          <small>
            <L10nMessage id="global.participant.bib" />
          </small>
        </Col>
        <Col sm={2}>
          {/**
            * once TPS finished adding address, display '--' when address is empty
            */}
          <strong>
            {
              hasAddress ? <AddressStatic address={uiAddress} nowrap locale={locale} /> : '--'
            }
          </strong>
          <br />
          {/**
              * once TPS finished adding address, always show this wording
              */}
          <small>
            {
              <L10nMessage id="page.event.participant.searchList.cityState" />
            }
          </small>
        </Col>
        <Col sm={4}>
          <strong>{raceName}</strong>
          <br />
          <small>
            <L10nMessage id="page.event.participant.searchList.race" />
          </small>
        </Col>
        <Col sm={2}>
          <NavLink to={`/participants/${participantId}${isKioskMode ? queryString : ''}`}>
            <Button type="secondary">
              <L10nMessage id="page.event.participant.searchList.viewResult" />
            </Button>
          </NavLink>
        </Col>
      </Row>
    </li>
  );
};

export default SearchParticipantListItem;
